export const server =
    process.env.REACT_APP_ENV === "local"
        ? "https://localhost:44385"
        : process.env.PUBLIC_URL;

export const webAPIUrl = `${server}/api`;

export const environmentBanner = process.env.REACT_APP_ENVIRONMENT_BANNER;